(function () {

    'use strict';

    angular.module('FotocApp')

    .component('sildeViews', { 
 
        templateUrl: (USE_TEMPLATE_CACHE ? '' :  window.BASE_PATH  + '../../src/') + 'editor/sildeViews.html',
        bindings: {}, 
        controller: ['$scope','$editorService', '$canvasService', '$document', '$lang', function ($scope, $editorService, $canvasService, $document, $lang) {

            var self = this;
            
            this.$editorService = $editorService;

            $scope.$lang = $lang;
            var amient_index_selected = 0;

            
            this.$onInit = function () {  
                        
                
                $scope.$watch('$ctrl.$editorService.data.layout_size', function (a, b) {
                    checkAmients()
                })
                $scope.$watch('$ctrl.$editorService.data.layout_id', function (a, b) {
                    checkAmients()
                })


            } 
            function checkAmients(){
                    
                if($editorService.getLayout()){
                    if($editorService.ui.view.type == 'ambient'){
                        
                        var amients = (angular.isDefined($editorService.getLayout().ambients) ? $editorService.getLayout().ambients : $editorService.ui.layouts[$editorService.data.layout_id].ambients)

                        if(amients[amient_index_selected]){
                            self.setView('ambient', amients[amient_index_selected], amient_index_selected);
                        }else{
                            self.setView('ambient', amients[amients.length-1], amients.length-1);
                        }
                       
                    } 
                 
                }
                
            }


            this.setView = function ($type, $id, $index){
                

                if(typeof($id) == 'undefined'){
                    $editorService.ui.view = {type: $type, id: null}
                }else{

                    amient_index_selected = $index
                    $editorService.ui.view = {type: $type, id: $id}
                }


            }


 
        }]
        
        
    })

})();